import dayjs from "dayjs";

export const findMinWorkDOB = (): string =>
  dayjs().subtract(14, "year").format("YYYY-MM-DD");
export const findMaxWorkDOB = (): string =>
  dayjs().subtract(115, "year").format("YYYY-MM-DD");
